<template>
  <v-card>
    <div id="PDFORG" class="modal-wrapper-pdf">
      <!-- Renombrada clase para evitar conflicto con .modal de Organization.vue -->
      <div class="modal-content-pdf">
        <div class="modal-header-pdf" style="flex-shrink: 0;">
          <s-toolbar
            color="primary"
            dark
            label="Imprimir PDF "
            close
            @close="close()"
            print
            @print="PrintPdf()"
          >
            <v-select
              v-model="selectedFormatKey"
              :items="formatItems"
              label="Formato de Página"
              dense
              outlined
              hide-details
              style="max-width: 200px; margin-right: 16px;"
              item-text="text"
              item-value="value"
            ></v-select>
          </s-toolbar>
        </div>
        <div id="testHtml" ref="testHtml" style="flex-shrink: 0;">
          <table id="table_cabecera">
            <tr>
              <td>
                <img width="200px" src="../../../public/static/logo_sp.png" />
              </td>
              <td style="text-align: center">
                {{
                  "ORGANIGRAMA DE " + (this.selected?.name || "LA ORGANIZACIÓN")
                }}
              </td>
              <td style="text-align: center">
                <table
                  style="border-collapse: collapse; width: 100%; margin: auto"
                >
                  <tr>
                    <td style="text-align: right">Codigo :</td>
                    <td style="padding-left: 8px">RH-OG-001</td>
                  </tr>
                  <tr>
                    <td style="text-align: right">Version :</td>
                    <td style="padding-left: 8px">01</td>
                  </tr>
                  <tr>
                    <td style="text-align: right">Fecha de Creacion :</td>
                    <td style="padding-left: 8px">06/03/2024</td>
                  </tr>
                  <tr>
                    <td style="text-align: right">Fecha de Revision :</td>
                    <td style="padding-left: 8px">{{ ultimateRevision }}</td>
                  </tr>
                  <tr>
                    <td style="text-align: right">Pagina :</td>
                    <td style="padding-left: 8px">1 de 1</td>
                  </tr>
                  <tr>
                    <td style="text-align: right">Anexos :</td>
                    <td style="padding-left: 8px">00</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <div class="contenido-pdf" style="flex-grow: 1; overflow: auto;">
          <div v-show="TypeDiagram == false" class="org-container-pdf">
            <org
              v-if="selected && selected?.name"
              ref="orgDATA"
              :managerNameView="false"
              :TypePosition="TypePosition"
              :level="selected.level"
              :TypeNivel="TypeNivel"
              :parent="selected"
              :report="false"
              @upOrg="refreshLines"
            >
            </org>
          </div>
          <div v-show="TypeDiagram == true" class="org-container-pdf">
            <org-area
              v-if="selected && selected?.name"
              ref="orgDATA2"
              :managerNameView="false"
              :TypePosition="TypePosition"
              :TypeNivel="TypeNivel"
              :parent="selected"
              :report="false"
            >
            </org-area>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
html2canvas;
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Org from "./../../components/Org/Org.vue";
import OrgArea from "./../../components/Org/OrgArea.vue";
import "jspdf-autotable";
import _sGenParam from "../../services/General/ParameterService";
export default {
  components: { Org, OrgArea },
  props: {
    selected: {
      default: null,
      type: Object,
    },
    TypeNivel: {
      type: Number,
      default: 0,
    },
    TypeDiagram: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      TypePosition: 0,
      ultimateRevision: "",
      selectedFormatKey: "a4_portrait", // Formato por defecto
      pageFormats: {
        a4_portrait: {
          name: "a4",
          width: 210,
          height: 297,
          orientation: "portrait",
          label: "A4 Vertical",
        },
        a4_landscape: {
          name: "a4",
          width: 297,
          height: 210,
          orientation: "landscape",
          label: "A4 Horizontal",
        },
        a3_portrait: {
          name: "a3",
          width: 297,
          height: 420,
          orientation: "portrait",
          label: "A3 Vertical",
        },
        a3_landscape: {
          name: "a3",
          width: 420,
          height: 297,
          orientation: "landscape",
          label: "A3 Horizontal",
        },
        a2_portrait: {
          name: "a2",
          width: 420,
          height: 594,
          orientation: "portrait",
          label: "A2 Vertical",
        },
        a2_landscape: {
          name: "a2",
          width: 594,
          height: 420,
          orientation: "landscape",
          label: "A2 Horizontal",
        },
        a1_portrait: {
          name: "a1",
          width: 594,
          height: 841,
          orientation: "portrait",
          label: "A1 Vertical",
        },
        a1_landscape: {
          name: "a1",
          width: 841,
          height: 594,
          orientation: "landscape",
          label: "A1 Horizontal",
        },
      },
    };
  },
  computed: {
    // Para usar en un v-select si quieres añadir una UI para cambiar el formato
    formatItems() {
      return Object.keys(this.pageFormats).map((key) => ({
        text: this.pageFormats[key].label,
        value: key,
      }));
    },
  },
  methods: {
    refreshLines() {
      this.$nextTick(() => {
        if (this.$refs.orgDATA && this.$refs.orgDATA.$refs.drawLines) {
          this.$refs.orgDATA.$refs.drawLines.refreshLines();
        }
      });
    },
    async PrintPdf() {
      await this.$nextTick();

      const orgElement = this.TypeDiagram
        ? document.getElementById("orgArea")
        : document.getElementById("org");
      if (!orgElement) {
        console.error(
          "Elemento del organigrama (org o orgArea) no encontrado."
        );
        return;
      }

      const headerElement = this.$refs.testHtml;
      if (!headerElement) {
        console.error("Elemento de la cabecera (testHtml) no encontrado.");
        return;
      }

      const currentFormatDetails = this.pageFormats[this.selectedFormatKey];
      if (!currentFormatDetails) {
        console.error(
          "Formato de página seleccionado no válido:",
          this.selectedFormatKey
        );
        alert(
          "Formato de página no válido seleccionado. Usando A4 Apaisado por defecto."
        );
        // Podrías forzar un formato por defecto si el seleccionado es inválido
        // this.selectedFormatKey = 'a4_landscape';
        // currentFormatDetails = this.pageFormats[this.selectedFormatKey];
        return;
      }

      const html2canvasOptions = {
        scale: 3,
        useCORS: true,
        logging: false,
      };

      try {
        const headerCanvas = await html2canvas(
          headerElement,
          html2canvasOptions
        );
        const orgCanvas = await html2canvas(orgElement, {
          ...html2canvasOptions,
          width: orgElement.scrollWidth,
          height: orgElement.scrollHeight,
        });

        const PAGE_FORMAT_NAME = currentFormatDetails.name;
        const PAGE_ORIENTATION = currentFormatDetails.orientation;
        const PAGE_WIDTH_MM = currentFormatDetails.width;
        const PAGE_HEIGHT_MM = currentFormatDetails.height;

        const pdf = new jsPDF({
          orientation: PAGE_ORIENTATION,
          unit: "mm",
          format: PAGE_FORMAT_NAME,
        });

        const MARGIN_MM = 10;
        const PRINTABLE_WIDTH_MM = PAGE_WIDTH_MM - 2 * MARGIN_MM;
        const PRINTABLE_PAGE_HEIGHT_MM = PAGE_HEIGHT_MM - 2 * MARGIN_MM;

        const headerImgData = headerCanvas.toDataURL("image/png");
        const headerProps = pdf.getImageProperties(headerImgData);
        const headerPdfWidth = PRINTABLE_WIDTH_MM;
        const headerPdfHeight =
          (headerProps.height * headerPdfWidth) / headerProps.width;
        pdf.addImage(
          headerImgData,
          "PNG",
          MARGIN_MM,
          MARGIN_MM,
          headerPdfWidth,
          headerPdfHeight
        );

        const orgStartY_firstPage_Mm = MARGIN_MM + headerPdfHeight + 2;
        const orgAvailableHeight_firstPage_Mm =
          PAGE_HEIGHT_MM - MARGIN_MM - orgStartY_firstPage_Mm;

        const ASSUMED_DPI = 96 * html2canvasOptions.scale;
        const PX_PER_MM = ASSUMED_DPI / 25.4;

        const totalOrgWidthPx = orgCanvas.width;
        const totalOrgHeightPx = orgCanvas.height;
        const totalOrgWidthMm = totalOrgWidthPx / PX_PER_MM;
        const totalOrgHeightMm = totalOrgHeightPx / PX_PER_MM;

        if (
          totalOrgWidthMm <= PRINTABLE_WIDTH_MM &&
          totalOrgHeightMm <= orgAvailableHeight_firstPage_Mm &&
          orgAvailableHeight_firstPage_Mm > 0
        ) {
          const orgImgData = orgCanvas.toDataURL("image/png");
          let finalOrgW = totalOrgWidthMm;
          let finalOrgH = totalOrgHeightMm;
          const ratioW = PRINTABLE_WIDTH_MM / finalOrgW;
          const ratioH = orgAvailableHeight_firstPage_Mm / finalOrgH;
          const ratio = Math.min(ratioW, ratioH, 1);
          finalOrgW *= ratio;
          finalOrgH *= ratio;
          const orgX = MARGIN_MM + (PRINTABLE_WIDTH_MM - finalOrgW) / 2;
          const orgY =
            orgStartY_firstPage_Mm +
            (orgAvailableHeight_firstPage_Mm - finalOrgH) / 2;
          pdf.rect(orgX, orgY, finalOrgW, finalOrgH, "S"); // 'S' es para stroke (borde)

          pdf.addImage(orgImgData, "PNG", orgX, orgY, finalOrgW, finalOrgH);
        } else {
          let processedHeightPx = 0;
          let isFirstSliceOverall = true;
          const sliceWidthPxOnCanvasPerPage = Math.floor(
            PRINTABLE_WIDTH_MM * PX_PER_MM
          );

          while (processedHeightPx < totalOrgHeightPx) {
            let pageAvailableHeightForOrgMm = isFirstSliceOverall
              ? orgAvailableHeight_firstPage_Mm
              : PRINTABLE_PAGE_HEIGHT_MM;

            if (pageAvailableHeightForOrgMm <= 0 && isFirstSliceOverall) {
              isFirstSliceOverall = false;
              pdf.addPage(PAGE_FORMAT_NAME, PAGE_ORIENTATION);
              pageAvailableHeightForOrgMm = PRINTABLE_PAGE_HEIGHT_MM;
            }

            let sliceHeightPxOnCanvasCurrentStrip = Math.floor(
              pageAvailableHeightForOrgMm * PX_PER_MM
            );
            sliceHeightPxOnCanvasCurrentStrip = Math.min(
              sliceHeightPxOnCanvasCurrentStrip,
              totalOrgHeightPx - processedHeightPx
            );

            if (
              sliceHeightPxOnCanvasCurrentStrip <= 0 &&
              totalOrgHeightPx - processedHeightPx > 0
            ) {
              if (!isFirstSliceOverall) {
                pdf.addPage(PAGE_FORMAT_NAME, PAGE_ORIENTATION);
              } else {
                // Si es el primer trozo y no cabe, ya se debió añadir página arriba o se hará en el bucle de ancho
                isFirstSliceOverall = false;
              }
              pageAvailableHeightForOrgMm = PRINTABLE_PAGE_HEIGHT_MM; // Actualizar para la nueva página
              sliceHeightPxOnCanvasCurrentStrip = Math.floor(
                pageAvailableHeightForOrgMm * PX_PER_MM
              );
              sliceHeightPxOnCanvasCurrentStrip = Math.min(
                sliceHeightPxOnCanvasCurrentStrip,
                totalOrgHeightPx - processedHeightPx
              );
              if (sliceHeightPxOnCanvasCurrentStrip <= 0) break;
            } else if (sliceHeightPxOnCanvasCurrentStrip <= 0) {
              break;
            }

            let processedWidthPx = 0;
            let isFirstHorizontalSliceOfStrip = true;

            while (processedWidthPx < totalOrgWidthPx) {
              if (!isFirstSliceOverall) {
                // Si no es el primer trozo general del organigrama
                pdf.addPage(PAGE_FORMAT_NAME, PAGE_ORIENTATION);
              } else {
                // Si es el primer trozo general, pero no el primer trozo horizontal de esta tira vertical
                // Y además, la cabecera ya fue puesta (isFirstSliceOverall se vuelve false después del primer trozo)
                // Esta lógica es compleja. Simplificamos: si no es el primer trozo *general*, añade página.
                // La primera página (con cabecera) se maneja con isFirstSliceOverall.
                // Los trozos subsiguientes en la misma tira vertical pero diferentes columnas horizontales necesitan nueva página.
                if (!isFirstHorizontalSliceOfStrip) {
                  pdf.addPage(PAGE_FORMAT_NAME, PAGE_ORIENTATION);
                }
              }

              const sx = processedWidthPx;
              const sy = processedHeightPx;
              const sWidth = Math.min(
                sliceWidthPxOnCanvasPerPage,
                totalOrgWidthPx - processedWidthPx
              );
              const sHeight = sliceHeightPxOnCanvasCurrentStrip;

              const sliceCanvas = document.createElement("canvas");
              sliceCanvas.width = sWidth;
              sliceCanvas.height = sHeight;
              const sliceCtx = sliceCanvas.getContext("2d");
              sliceCtx.drawImage(
                orgCanvas,
                sx,
                sy,
                sWidth,
                sHeight,
                0,
                0,
                sWidth,
                sHeight
              );
              const sliceImgData = sliceCanvas.toDataURL("image/png");

              const currentPdfY_start =
                isFirstSliceOverall && isFirstHorizontalSliceOfStrip
                  ? orgStartY_firstPage_Mm
                  : MARGIN_MM;
              const currentPdfPageAvailableHeight =
                isFirstSliceOverall && isFirstHorizontalSliceOfStrip
                  ? orgAvailableHeight_firstPage_Mm
                  : PRINTABLE_PAGE_HEIGHT_MM;

              const sliceNativeWidthMm = sWidth / PX_PER_MM;
              const sliceNativeHeightMm = sHeight / PX_PER_MM;
              let finalSliceW = sliceNativeWidthMm;
              let finalSliceH = sliceNativeHeightMm;
              const ratioW_slice = PRINTABLE_WIDTH_MM / finalSliceW;
              const ratioH_slice = currentPdfPageAvailableHeight / finalSliceH;
              const ratio_slice = Math.min(ratioW_slice, ratioH_slice, 1);
              finalSliceW *= ratio_slice;
              finalSliceH *= ratio_slice;
              const sliceX_pdf =
                MARGIN_MM + (PRINTABLE_WIDTH_MM - finalSliceW) / 2;
              const sliceY_pdf =
                currentPdfY_start +
                (currentPdfPageAvailableHeight - finalSliceH) / 2;
              pdf.addImage(
                sliceImgData,
                "PNG",
                sliceX_pdf,
                sliceY_pdf,
                finalSliceW,
                finalSliceH
              );

              isFirstSliceOverall = false; // Después del primer trozo (0,0), ya no es el "primerísimo"
              isFirstHorizontalSliceOfStrip = false; // Para la siguiente iteración horizontal en la misma tira
              processedWidthPx += sWidth;
            }
            processedHeightPx += sliceHeightPxOnCanvasCurrentStrip;
          }
        }
        pdf.save(`Organigrama_${this.selectedFormatKey}.pdf`);
      } catch (error) {
        console.error("Error al generar el PDF:", error);
      }
    },
    close() {
      this.$emit("closedialogPdf");
    },
    loadParameters() {
      _sGenParam
        .search({ PrmName: "RH-OG-001" }, this.$fun.getUserID())
        .then((resp) => {
          if (resp.status == 200) {
            this.ultimateRevision = resp.data.PrmValue;
          }
        });
    },
  },
  mounted() {
    this.loadParameters();
  },
};
</script>

<style>
body,
html {
  margin: 0;
  padding: 0;
}

.modal-wrapper-pdf {
  /* Anteriormente .modal */
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Fondo semitransparente */
  z-index: 1000;
  /* Asegurar que esté por encima de otros elementos */
}

.modal-content-pdf {
  /* Anteriormente .modal-content */
  background-color: #fff;
  width: 297mm;
  /* A4 Ancho */
  height: 210mm;
  /* A4 Alto */
  padding: 0mm;
  border: 1px solid #000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /* Evita doble scrollbar en el modal-content mismo */
}

.modal-header-pdf {
  /* Anteriormente .modal-header */
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #3f51b5;
  /* Color primario */
  color: white;
}

#table_cabecera {
  width: 100%;
  background-color: #fff;
  border-collapse: collapse;
}

.contenido-pdf {
  /* Anteriormente .contenido */
  /* flex-grow: 1; ya está inline */
  /* overflow: auto; ya está inline */
  /* Para depuración: border: 2px solid red; */
}

.org-container-pdf {
  /* Nuevo contenedor para <org> y <org-area> */
  display: inline-block;
  /* Clave para que el tamaño se ajuste al hijo (#org o #orgArea) */
  min-width: 100%;
  /* Asegura que ocupe al menos el ancho del área de scroll */
  min-height: 100%;
  /* Asegura que ocupe al menos el alto del área de scroll */
  vertical-align: top;
  /* Para depuración: border: 2px solid blue; padding: 5px; */
}

@media print {
  .graph {
    position: static !important;
    z-index: auto !important;
  }

  #org {
    position: static !important;
    background: white !important;
  }
}
</style>
